<!-- Venue Travel Info and Attractions -->
<div class="container my-5">
  <span
    class="d-flex align-items-center justify-content-center text-muted mb-3 w-100"
  >
    Please check the Google Map from the
    <a routerLink="/event/all" class="ms-1 text-decoration-none text-theme"
      >Event Details</a
    >
  </span>
  <h2 class="text-center mb-4">How to Reach the Wedding Mahal - Tirunelveli</h2>

  <div class="row g-4">
    <div class="col-md-4">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            From New Bus Stand <span class="text-muted">(3 km)</span>
          </h5>
          <p><strong>Cab:</strong> ₹180 – ₹200</p>
          <p><strong>Auto:</strong> ₹100 – ₹120</p>
          <p><strong>Ola / Rapido:</strong> Available</p>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            From Old Bus Stand <span class="text-muted">(8 km)</span>
          </h5>
          <p><strong>Cab:</strong> ₹210 – ₹240</p>
          <p><strong>Auto:</strong> ₹120 – ₹140</p>
          <p><strong>Ola / Rapido:</strong> Available</p>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            From Railway Station <span class="text-muted">(9 km)</span>
          </h5>
          <p><strong>Cab:</strong> ₹290 – ₹310</p>
          <p><strong>Auto:</strong> ₹140 – ₹160</p>
          <p><strong>Ola / Rapido:</strong> Available</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4 mt-3">
    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            From Tuticorin Airport <span class="text-muted">(40 km)</span>
          </h5>
          <p><strong>Cab:</strong> Approx. ₹1000 – ₹1200</p>
          <p>
            <strong>Ola / Uber / Rapido:</strong>
            <span class="text-danger">Not Available</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <h2 class="text-center mt-5 mb-4">
    How to Reach the Reception Venue – Karungal
  </h2>

  <div class="row g-4">
    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            From Nagercoil Bus Stand <span class="text-muted">(24 km)</span>
          </h5>
          <p><strong>Auto Fare:</strong> ₹600 approx</p>
          <p>
            <strong>Ola / Uber / Rapido:</strong>
            <span class="text-danger">Not Available</span>
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            From Nagercoil Railway Station
            <span class="text-muted">(26 km)</span>
          </h5>
          <p><strong>Auto Fare:</strong> ₹700 approx</p>
          <p>
            <strong>Ola / Uber / Rapido:</strong>
            <span class="text-danger">Not Available</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4 mt-3">
    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            From Trivandrum Airport <span class="text-muted">(55 km)</span>
          </h5>
          <p><strong>Cab:</strong> ₹2000 approx</p>
          <p><strong>Ola / Uber:</strong> Available</p>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">
            Nearest Railway Station: Palliyadi
            <span class="text-muted">(6 km)</span>
          </h5>
          <p><strong>Auto Fare:</strong> ₹120 approx</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4 mt-3">
    <div class="col">
      <div class="card h-100 shadow-sm">
        <div class="card-body pb-1">
          <h5 class="card-title">Public Bus from Nagercoil</h5>
          <p>
            Take any bus going to Thengapattinam, Melmidalam, or Karungal
            <strong>9A, 9C, 9D, 9E, 9F, 7F, 7A, 309A, 309C, 310B</strong>.
          </p>
          <p>
            Get down at <strong>Karumavilai CSI Church Stop</strong> (directly
            in front of the reception venue).
          </p>
          <p><strong>Bus Fare:</strong> ₹30 approx</p>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4 text-center">
    <p class="mb-1">
      <strong>For any queries, clarifications and support, contact:</strong>
    </p>
    <p class="mb-0">
      Anand -
      <a href="tel:9489825808" class="text-decoration-none text-theme"
        ><img src="/assets/images/phone-icon.svg" /> 9489825808</a
      >
    </p>
    <p>
      Vasanth -
      <a href="tel:9442830972" class="text-decoration-none text-theme"
        ><img src="/assets/images/phone-icon.svg" /> 9442830972</a
      >
    </p>
  </div>
</div>
